module.exports = __webpack_public_path__ + "static/media/ocean-waves-noise.96caf2da.mp3";